<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="empAbnormalHours"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="统计日期">
            <el-date-picker
                v-model="filter.statDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 180px"
                clearable
                placeholder="请选择日期"/>
          </el-form-item>
          <el-form-item label="员工编号">
            <el-input v-model.trim="filter.empNo" placeholder="请输入员工编号" clearable/>
          </el-form-item>
          <el-form-item label="员工姓名">
            <el-input v-model.trim="filter.empName" placeholder="请输入员工姓名" clearable/>
          </el-form-item>
          <el-form-item label="工时类型">
            <el-select v-model="filter.empAbnormalHourType" clearable placeholder="请选择工时类型" style="width:180px">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <emp-abnormal-hour-edit ref="empAbnormalHourEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import EmpAbnormalHourEdit from "./EmpAbnormalHourEdit";

  export default {
    name: "EmpAbnormalHourList",
    components: { EmpAbnormalHourEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
        },
        typeOptions: [
          { label: "年假", value: 1 },
          { label: "婚假", value: 2 },
          { label: "丧假", value: 3 },
          { label: "产假/陪产假", value: 4 },
          { label: "事假", value: 5 },
          { label: "调休", value: 6 },
          { label: "顶岗", value: 7 },
          { label: "员工个人加班", value: 8 },
          { label: "班组集体加班", value: 9 },
          { label: "工伤医疗期", value: 10 },
          { label: "外出培训", value: 11 },
          { label: "外出公干/跨厂支援", value: 12 },
          { label: "居家办公", value: 13 },
          { label: "停工待料带薪", value: 14 },
          { label: "隔离观察带薪", value: 15 },
          { label: "其他特殊工时", value: 16 },
        ],
        filter: {
          statDate: "",
          empNo: "",
          empName: "",
          empAbnormalHourType: null,
        },
        columnsProperty: [
          { tooltip: true, key: "statDate", align: "center", width: 110 },
          { tooltip: true, key: "empNo", align: "center", width: 120 },
          { tooltip: true, key: "empName", align: "center", width: 110 },
          { key: "empAbnormalHourTypeName", align: "center", width: 160 },
          { key: "abnormalDuration", align: "center", width: 110 },
          { tooltip: true, key: "createTime", align: "center", width: 150 },
          { key: "action", width: 140, slot: "action", fixed: "right" },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      addEditHandle(row) {
        this.$refs.empAbnormalHourEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "empAbnormalHours", row.id).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
